// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { FunctionComponent, ReactElement } from "react";
import { Box, CardMedia, Paper, Stack, Typography } from "@mui/material";
import UnauthorizedImg from '../images/unauthorized.svg';

type UnauthorizedPagePropsInterface = {};

/**
 * Page for unauthorized user login redirect.
 *
 * @param {UnauthorizedPagePropsInterface} props - Props injected to the component.
 *
 * @return {React.ReactElement}
 */
export const UnauthorizedPage: FunctionComponent<UnauthorizedPagePropsInterface> = (): ReactElement => {
    return (
        <Box>
            <Box height="100vh" width="100vw" sx={{ display: "flex", flexDirection: "column", justifyContent: 'center', alignItems: 'center' }}>
                <Paper elevation={1} sx={{ height: "90vh", width: "95vw", display: "flex", justifyContent: 'center' }}>
                    <Stack direction="column" spacing={2} justifyContent="center" alignItems="center">
                        <CardMedia
                            sx={{ height: "40vh", width: "40vh" }}
                            component="img"
                            image={UnauthorizedImg}
                            alt="Unauthorized Image"
                        />
                        <Typography p={3} align="center" variant="h3">Unauthorized!</Typography>
                        <Typography align="center" variant="h5">user does not have the required permission.</Typography>
                    </Stack>
                </Paper>
            </Box>
        </Box>
    );
};
